export default {
	NEW: 'new',
	LOADING: 'loading',
	READY: 'ready',
	WAITING_FOR_USER_START: 'waitingForUserStart',
	REMOVING: 'removing',
	ERROR: 'error',
};
